// Shared styling tokens for Wave F road editors (matches PIDEditor / SLDEditor look).
export const card    = { background: "var(--pf-surface)", border: "1px solid var(--pf-border)", borderRadius: 6 };
export const btn     = { padding: "5px 10px", fontSize: 11, background: "#F26B1F",
                          color: "#0e0e10", border: "1px solid #F26B1F",
                          borderRadius: 4, cursor: "pointer", fontWeight: 600 };
export const btnGhost = { padding: "5px 10px", fontSize: 11, background: "transparent",
                            color: "var(--pf-text)", border: "1px solid var(--pf-border)",
                            borderRadius: 4, cursor: "pointer" };
export const label   = { fontSize: 9, color: "var(--pf-muted)", textTransform: "uppercase",
                          letterSpacing: 0.6, fontWeight: 600 };
export const inputStyle = { width: "100%", padding: "4px 6px", fontSize: 11,
                              fontFamily: "monospace", background: "#fff", color: "#222",
                              border: "1px solid var(--pf-border)", borderRadius: 3 };

export const STATUS_COLOR = {
  PASS: "#22c55e", WARN_BELOW_RULING: "#f59e0b", FAIL: "#ef4444",
};
